import { FC } from 'react';
import { Link } from 'react-router-dom';

import PopIn from 'components/PopIn';

import locales from './locales';
import { Close, CloseButton, Wrapper } from './styles';

interface ModalProps {
  onClose?: () => void;
  destinationOnClose?: string;
  level?: 'modal' | 'alert';
  children: React.ReactNode;
}

const Modal: FC<ModalProps> = ({
  children,
  destinationOnClose,
  level = 'modal',
  // Empty function used below as an easier to handle default value
  onClose = (): void => {},
}) => (
  <PopIn level={level}>
    <Wrapper>
      <Close>
        {destinationOnClose ? (
          <Link to={destinationOnClose}>
            <CloseButton onClick={onClose}>{locales.exit}</CloseButton>
          </Link>
        ) : (
          <CloseButton onClick={onClose}>{locales.exit}</CloseButton>
        )}
      </Close>
      {children}
    </Wrapper>
  </PopIn>
);

export default Modal;
